var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 19.5,
    height: 13.7857,
    rx: 1.75,
    fill: "white",
    stroke: "#F5F5F5",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_780_8755",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 15
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 19.5,
    height: 13.7857,
    rx: 1.75,
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_780_8755)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14.2858,
    width: 5.71429,
    height: 14.2857,
    fill: "#E13100"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 14.2857H5.71429V0H0V14.2857Z",
    fill: "#E13100"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6834 6.41186C11.4644 6.63086 11.0944 6.43283 11.1551 6.12913L11.4285 4.76195L10.4762 5.23814L9.99996 3.80957L9.52377 5.23814L8.57139 4.76195L8.84482 6.12913C8.90556 6.43283 8.53554 6.63086 8.31654 6.41186C8.1943 6.28962 7.9961 6.28962 7.87386 6.41186L7.61901 6.66671L6.66663 6.19052L7.14282 7.1429L6.90233 7.38339C6.77215 7.51357 6.77215 7.72462 6.90233 7.8548L8.0952 9.04767H9.52377L9.76186 10.4762H10.2381L10.4762 9.04767H11.9047L13.0976 7.8548C13.2278 7.72462 13.2278 7.51357 13.0976 7.38339L12.8571 7.1429L13.3333 6.19052L12.3809 6.66671L12.1261 6.41186C12.0038 6.28962 11.8056 6.28962 11.6834 6.41186Z",
    fill: "#E13100"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCa);
export default __webpack_public_path__ + "static/media/CA.667bee7e1c2167be8d7098425a653968.svg";
export { ForwardRef as ReactComponent };